import React from "react";
import * as Yup from "yup";
import moment from "moment";
import { useParams } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import EditorContainer from "../../components/EditorContainer";
import { createSim, updateSim, getSim } from "../../api/simcards";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { it } from "../../utils/content";

const schema = () =>
  Yup.object({
    number: Yup.string()
      .required("Numero di telefono obbligatorio")
      .min(5, "Il numero di telefono deve essere almeno di 5 cifre"),
    iccid: Yup.string()
      .required("Il codice ICCID èbbligatorio")
      .nullable(),
    carrier: Yup.string()
      .required("Operatore è un campo obbligatorio")
      .nullable(),
    type: Yup.string()
      .required("Il tipo di SIM è obbligatorio")
      .nullable(),
    createdat: Yup.string()
      .ensure()
      .required("La data inserimento è obbligatoria")
      .min(8, `La data inserimento è obbligatoria`)
  });

const SimEditor = ({ readOnly }) => {
  const { id } = useParams();
  const { domains } = useAuth0();

  const onCreate = async entity => {
    const result = await createSim({ ...entity });
    return result;
  };

  const onLoad = async id => {
    const sim = await getSim(id);
    return sim;
  };

  const onUpdate = async entity => {
    const result = await updateSim(entity);
    return result;
  };

  return (
    <EditorContainer
      key={id ? `${id}-sim` : "new-sim"}
      canSave={true}
      schema={schema}
      readOnly={readOnly}
      onCreate={onCreate}
      onUpdate={onUpdate}
      onLoad={onLoad}
      optionalNav={{ link: "/backoffice/simcards", text: "SIM" }}
      redirRoot="/backoffice/simcards"
      title={el => `SIM ${el.iccid || "NUOVA SIM"}`}
      children={(frmProps, containerHandleChange) => (
        <Row>
          <Col sm="6" xs="12">
            <strong className="mt-2">Operatore</strong>
            <Dropdown
              filter
              disabled={readOnly ? true : false}
              filterBy="label"
              className={frmProps.errors.carrier ? "p-error" : ""}
              showClear={true}
              style={{ width: "100%" }}
              value={frmProps.values["carrier"]}
              options={domains.carriers}
              onChange={e => containerHandleChange("carrier", e)}
            />
            {frmProps.errors.carrier ? (<div className="invalid-feedback">{frmProps.errors.carrier}</div>) : null}
          </Col>
          <Col sm="6" xs="12">
            <strong className="mt-2">Tipo SIM</strong>
            <Dropdown
              filter
              filterBy="label"
              id="type"
              disabled={readOnly ? true : false}
              className={frmProps.errors.type ? "p-error" : ""}
              value={frmProps.values["type"]}
              showClear={true}
              style={{ width: "100%" }}
              options={domains.simTypes}
              onChange={e => containerHandleChange("type", e)}
            />
            {frmProps.errors.type ? (<div className="invalid-feedback">{frmProps.errors.type}</div>) : null}
          </Col>
          <Col sm="6" xs="12">
            <strong className="mt-2">ICCID</strong>
            <InputText
              className={frmProps.errors.iccid ? "p-error" : ""}
              value={frmProps.values["iccid"] || ""}
              style={{ width: "100%" }}
              onChange={e => containerHandleChange("iccid", e)}
            />
            {frmProps.errors.iccid ? (<div className="invalid-feedback">{frmProps.errors.iccid}</div>) : null}
          </Col>
          <Col sm="6" xs="12">
            <strong className="mt-2">Telefono</strong>
            <InputText
              maxLength={15}
              className={frmProps.errors.number ? "p-error" : ""}
              value={frmProps.values["number"] || ""}
              style={{ width: "100%" }}
              onChange={e => containerHandleChange("number", e)}
            />
            {frmProps.errors.number ? (<div className="invalid-feedback">{frmProps.errors.number}</div>) : null}
          </Col>
          <Col sm="3" xs="12">
            <div><strong className="mt-2">Data Inserimento</strong></div>
            <Calendar
              locale={it}
              disabled={readOnly ? true : false}
              monthNavigator={true}
              yearNavigator={true}
              showButtonBar={true}
              maxDate={new Date()}
              className={frmProps.errors.createdat ? "p-error" : ""}
              yearRange="1900:2099"
              value={
                frmProps.values["createdat"]
                  ? moment(frmProps.values["createdat"]).toDate()
                  : ""
              }
              onChange={e => containerHandleChange("createdat", e)}
              dateFormat="dd/mm/yy"
              showIcon={true}
            />
            {frmProps.errors.createdat ? (<div className="invalid-feedback">{frmProps.errors.createdat}</div>) : null}
          </Col>
          <Col sm="3" xs="12">
              <strong className="mt-2">Status</strong>
              <Dropdown
                filter
                filterBy="label"
                id="status"
                className={frmProps.errors.type ? "p-error" : ""}
                value={frmProps.values["status"]}
                showClear={true}
                style={{ width: "100%" }}
                options={[
                  { label: "inserito", value: "inserito" },
                  { label: "associato", value: "associato" },
                  { label: "dismesso", value: "dismesso" }
                ]}
                onChange={e => containerHandleChange("status", e)}
              />
              {frmProps.errors.type ? (<div className="invalid-feedback">{frmProps.errors.type}</div>) : null}
            </Col>
          {frmProps.values["imei"] && (
            <Col sm="6" xs="12">
              <strong className="mt-2">IMEI dispositivo</strong>
              <InputText
                disabled
                className={frmProps.errors.model ? "p-error" : ""}
                value={frmProps.values["imei"]}
                style={{ width: "100%" }}
              />
            </Col>
          )}
        </Row>
      )}
    />
  );
};
export default SimEditor;
